<template>
    <v-dialog
        :value="isOpen"
        max-width="1000px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Szczegóły metryki dokumentu <strong>(ZS {{ shippingOrderData.number }})</strong>
                </h1>
            </v-card-title>

            <v-card-text>
                <v-col cols="12">
                    <v-expansion-panels
                        accordion
                        multiple
                    >
                        <v-expansion-panel
                            v-for="(change, changeIndex) in detaliedShipmentsOrderHistory"
                            :key="changeIndex"
                        >
                            <v-expansion-panel-header>
                                <v-row no-gutters align="center" dense>
                                    <v-col cols="auto">
                                        <span>
                                            <h1 class="text-subtitle-1">
                                                <template>
                                                    {{ change.change.verboseName }} {{ setName(change.change.code, changeIndex) }}
                                                </template>
                                            </h1>
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row>
                                    <v-col sm="6">
                                        <v-col v-if="change.change.code === 3 || change.change.code === 4" sm="6" class="text-no-wrap">
                                            <strong>Dla adresu:</strong> {{ setAddressName(changeIndex) }}
                                        </v-col>
                                        <v-col v-if="change.change.code === 4" sm="6" class="text-no-wrap">
                                            <strong>Dla pakowania:</strong> {{ setPackageName(changeIndex) }}
                                        </v-col>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-data-table
                                            :headers="detailedShipmentsOrderHistoryHeaders"
                                            :items="change.diffs"
                                            :items-per-page="5"
                                            :page.sync="currentPaginationPage"
                                            :footer-props="{
                                                itemsPerPageText: 'Zmian na stronie',
                                                showFirstLastPage: false,
                                            }"
                                            :mobile-breakpoint="0"
                                            name="detailedShipmentsOrderHistoryData"
                                        >
                                            <template #item.changeType="{item}">
                                                {{ item.changeTypeLabel || $t('shippingOrder.crud.' + item.changeType) }}
                                            </template>
                                            <template #item.keyName="{item}">
                                                {{ item.keyLabel || $t('shippingOrder.' + item.keyName) }}
                                            </template>
                                            <template #item.oldValue="{item}">
                                                <template v-if="item.keyName == 'deliveryDateTime' || item.keyName == 'expeditionDateTime'">
                                                    {{ formatDate(item.oldValue) }}
                                                </template>
                                                <template v-else-if="item.keyName == 'setManuallyAmount'">
                                                    {{ item.oldValue ? 'Wybrana' : 'Nie wybrana' }}
                                                </template>
                                                <template v-else>
                                                    {{ parseEmptyValue(item.oldValue) }}
                                                </template>
                                            </template>
                                            <template #item.newValue="{item}">
                                                <template v-if="item.keyName == 'expeditionDateTime' || item.keyName == 'deliveryDateTime'">
                                                    {{ formatDate(item.newValue) }}
                                                </template>
                                                <template v-else-if="item.keyName == 'setManuallyAmount'">
                                                    {{ item.newValue ? 'Wybrana' : 'Nie wybrana' }}
                                                </template>
                                                <template v-else>
                                                    {{ parseEmptyValue(item.newValue) }}
                                                </template>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse'

export default {
    name: 'ShipmentsOrderDetailedHistoryDialog',
    mixins: [
        dateFormatter,
        parse
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        detaliedShipmentsOrderHistory: {
            type: Array,
            default: () => []
        },
        shippingOrderData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            currentPlateOrdersPaginationPage: null,
            currentPaginationPage: null,
            detailedShipmentsOrderHistoryHeaders: [
                {
                    text: 'Typ zmiany',
                    sortable: false,
                    value: 'changeType'
                },
                {
                    text: 'Nazwa',
                    align: 'center',
                    sortable: false,
                    value: 'keyName'
                },
                {
                    text: 'Wartość przed',
                    align: 'center',
                    sortable: false,
                    value: 'oldValue'
                },
                {
                    text: 'Wartość po',
                    align: 'center',
                    sortable: false,
                    value: 'newValue'
                },
            ]
        }
    },
    methods: {
        setName(code, index) {
            switch (code) {
                case 2:
                    return this.parseNullValue(this.detaliedShipmentsOrderHistory[index].addressName)
                case 3:
                    return this.parseNullValue(this.detaliedShipmentsOrderHistory[index].packageName)
                case 4:
                    return this.parseNullValue(this.detaliedShipmentsOrderHistory[index].wareName)
                default:
                    break
            }
        },
        setAddressName(index) {
            return this.detaliedShipmentsOrderHistory[index].addressName
        },
        setPackageName(index) {
            return this.detaliedShipmentsOrderHistory[index].packageName
        },
        parseNullValue(value) {
            return value ? value : ''
        },
        onClose() {
            this.$emit('on-close', this.shippingOrderData)
        }
    }
}
</script>